var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"app-footer"},[_c('div',{on:{"click":_vm.footerClick}},[_vm._v(" © 广州乐药信息科技有限公司 粤ICP备19151693号 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }